var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTildiScanBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3988_18323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 19.9997H17C16.7348 19.9997 16.4804 19.9119 16.2929 19.7556C16.1054 19.5993 16 19.3873 16 19.1663C16 18.9453 16.1054 18.7334 16.2929 18.5771C16.4804 18.4208 16.7348 18.333 17 18.333H19C19.7956 18.333 20.5587 18.0696 21.1213 17.6008C21.6839 17.1319 22 16.496 22 15.833V14.1663C22 13.9453 22.1053 13.7334 22.2929 13.5771C22.4804 13.4208 22.7348 13.333 23 13.333C23.2652 13.333 23.5196 13.4208 23.7071 13.5771C23.8946 13.7334 24 13.9453 24 14.1663V15.833C23.9984 16.9377 23.4711 17.9967 22.5338 18.7778C21.5964 19.5589 20.3256 19.9983 19 19.9997V19.9997Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.66667C0.734784 6.66667 0.48043 6.57887 0.292893 6.42259C0.105357 6.26631 0 6.05435 0 5.83333V4.16667C0.00158786 3.062 0.528882 2.00296 1.46622 1.22185C2.40356 0.440735 3.6744 0.00132321 5 0L7 0C7.26522 0 7.51957 0.0877974 7.70711 0.244078C7.89464 0.400358 8 0.61232 8 0.833333C8 1.05435 7.89464 1.26631 7.70711 1.42259C7.51957 1.57887 7.26522 1.66667 7 1.66667H5C4.20435 1.66667 3.44129 1.93006 2.87868 2.3989C2.31607 2.86774 2 3.50363 2 4.16667V5.83333C2 6.05435 1.89464 6.26631 1.70711 6.42259C1.51957 6.57887 1.26522 6.66667 1 6.66667V6.66667Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19.9997H5C3.6744 19.9983 2.40356 19.5589 1.46622 18.7778C0.528882 17.9967 0.00158786 16.9377 0 15.833L0 14.1663C0 13.9453 0.105357 13.7334 0.292893 13.5771C0.48043 13.4208 0.734784 13.333 1 13.333C1.26522 13.333 1.51957 13.4208 1.70711 13.5771C1.89464 13.7334 2 13.9453 2 14.1663V15.833C2 16.496 2.31607 17.1319 2.87868 17.6008C3.44129 18.0696 4.20435 18.333 5 18.333H7C7.26522 18.333 7.51957 18.4208 7.70711 18.5771C7.89464 18.7334 8 18.9453 8 19.1663C8 19.3873 7.89464 19.5993 7.70711 19.7556C7.51957 19.9119 7.26522 19.9997 7 19.9997Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 6.66667C22.7348 6.66667 22.4804 6.57887 22.2929 6.42259C22.1053 6.26631 22 6.05435 22 5.83333V4.16667C22 3.50363 21.6839 2.86774 21.1213 2.3989C20.5587 1.93006 19.7956 1.66667 19 1.66667H17C16.7348 1.66667 16.4804 1.57887 16.2929 1.42259C16.1054 1.26631 16 1.05435 16 0.833333C16 0.61232 16.1054 0.400358 16.2929 0.244078C16.4804 0.0877974 16.7348 0 17 0L19 0C20.3256 0.00132321 21.5964 0.440735 22.5338 1.22185C23.4711 2.00296 23.9984 3.062 24 4.16667V5.83333C24 6.05435 23.8946 6.26631 23.7071 6.42259C23.5196 6.57887 23.2652 6.66667 23 6.66667Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93311 4V15.3333",
    stroke: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4V15.3333",
    stroke: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 4V15.3333",
    stroke: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 4V15.3333",
    stroke: "#374957",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8667 4V15.3333",
    stroke: "#374957",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 4V15.3333",
    stroke: "#374957",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56689 4V15.3333",
    stroke: "#374957",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6333 4V15.3333",
    stroke: "#374957",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9668 4V15.3333",
    stroke: "#374957",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8999 4V15.3333",
    stroke: "#374957",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3988_18323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTildiScanBarcode);
export default __webpack_public_path__ + "static/media/tildi-scan-barcode.01313b7c3382f76d8d3c0e7e1c329c9c.svg";
export { ForwardRef as ReactComponent };